import { useEffect, useRef, useState } from "react";

export default function Reveal({ children, delay = 0, className = "", as: Tag = "div" }) {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setSeen(true);
            io.unobserve(node);
          }
        });
      },
      { threshold: 0.12 }
    );
    io.observe(node);
    return () => io.disconnect();
  }, []);

  const delayClass = `reveal-delay-${Math.min(5, delay)}`;
  return (
    <Tag
      ref={ref}
      className={`reveal ${seen ? "is-in" : ""} ${delay ? delayClass : ""} ${className}`}
    >
      {children}
    </Tag>
  );
}
